export function counter() {
  const items = document.querySelectorAll( '.js-counter' );
 
const isFloat = ( n ) => {
  return Number( n ) === n && n % 1 !== 0;
}
 
const getDecimalPointLength =( n ) => {
  return ( String( n ).split( '.' )[1] || '' ).length;
}
 
const observeAction = ( entries ) => {
  entries.forEach( entry => {
    if ( entry.isIntersecting ) {
      if ( ! entry.target.classList.contains( 'is-visible' ) ) {
        const counterEle = entry.target.querySelector( '.js-counterNum' );
        const from = parseFloat( entry.target.dataset.from || 0 );
        const to = parseFloat( entry.target.dataset.to || 0 );
        const duration = parseInt( entry.target.dataset.duration ) || 1500;
 
        if ( !Number.isFinite( from ) || !Number.isFinite( to ) || from > to ) {
          return false;
        }
 
        const increment = to - from;
        const deciamlPointLength = getDecimalPointLength( increment );
        const startTime = performance.now();
 
        const countUp = ( timestamp ) => {
          const elapsed = performance.now() - startTime;
          const countValue = ( from + ( ( elapsed / duration ) * increment ) ).toFixed( deciamlPointLength );
 
          if ( countValue >= to ) {
            counterEle.innerText = to.toLocaleString();
          } else {
            counterEle.innerText = parseFloat( countValue ).toLocaleString();
            requestAnimationFrame( countUp );
          }
        }
        
        requestAnimationFrame( countUp );
 
        entry.target.classList.add( 'is-visible' ); 
      }
    }
  } );
}
 
const options = {
  threshold: 1,
}
 
const obsever = new IntersectionObserver( observeAction, options );
 
items.forEach( target => {
  obsever.observe( target );
} );
}